import { gql } from 'graphql-tag'

export default gql`
  fragment BlockTerminalSpecsLazyFragment on BlockTerminalSpecs {
    sys {
      id
    }
    contentType: __typename
    variants: hardwareCollection {
      items {
        deviceVariant
      }
    }
  }
`
